import {  useContext, useEffect, useState } from "react"
import { AvatarBackgroundSelection, AvatarPositionSelection, AvatarSelection } from "../molecule/avatarSelection"
import { HorizontalLayout, VerticalLayout } from "./layout"
import { TitleDescriptionText } from "../atoms/titleDescription"
import { SimpleTextAreaForm } from "../atoms/input"
import { IconButton } from "../atoms/buttons"
import { VideoPlayer } from "../atoms/video"
import { getAPI, postAPI, updateAPI } from "../api/api"
import { PageContext } from "../App"

import avatar1 from "../assets/preview_target.webp";
import avatar2 from "../assets/preview_target-2.webp";
import avatar3 from "../assets/preview_target-3.webp";
import { Spinner } from "../atoms/spinner"

import { ProgressBarComplete } from "../molecule/timeBar"
import { Toast } from "../atoms/toast"

export const CreateAvatarComp = ({ id_module, moduleContent }) => {
    const toast = useContext(Toast);
    const avatars = [
        { id: 1, src: avatar1, alt: "Avatar 1" },
        { id: 2, src: avatar2, alt: "Avatar 2" },
        { id: 3, src: avatar3, alt: "Avatar 3" },
    ];

    const backgrounds = [
        { id_background: 1, colors: ["#FFDAB9", "#FFB997"], alt: "Peach Glow" },
        { id_background: 2, colors: ["#acdddaff", "#7dada9ff"], alt: "Lavender Mist" },
        { id_background: 3, colors: ["#f5c675ff", "#d4a656ff"], alt: "Warm Sand" },
    ];
    const [avatar, setAvatar] = useState(avatars[0]);
    const [avatarsBackgrounds, setAvatarsBackgrounds] = useState(backgrounds);
    const [avatarBackground, setAvatarBackground] = useState(backgrounds[0]);
    const [aiScene, setAiScene] = useState(false);
    const [avatarPosition, setAvatarPosition] = useState(2)
    const [sceneText, setSceneText] = useState("");
    const [isAudio, setIsAudio] = useState(false);
    const navigationContext = useContext(PageContext);
    const [aiLoading, setAiLoading] = useState(false);
    const [audioLoading, setAudioLoading] = useState(0);
    const [audioInterval, setAudioInterval] = useState(null);
    const loadAvatar = async () => {
        const query = `api/courses/lessons/modules/avatars/avatar?id_module=${id_module}`;
        const avatar1 = await getAPI(query)
        if (avatar1.status === "ok") {
            if (avatar1.data.length === 0) return;
            const copyAvatar = { ...avatar, ...avatar1["data"][0] };

            setSceneText(avatar1.data[0].script_text || "");
            setAvatarBackground(backgrounds[avatar1.data[0].id_background - 1] || backgrounds[0]);
            setAvatar(copyAvatar || null);
            isAvatarLoading(copyAvatar)
        }
    }
    useEffect(() => {
        loadAvatar();
    }, [id_module]);



    const [collapsed, setCollapsed] = useState(true);

    const isAvatarLoading = (avatar_copy) => {
        if (avatar_copy.progress === 1) {
            pollAvatarStatus()
            return setAiLoading(true);
        }
        return setAiLoading(false);
    }

    const handleAiScene = async () => {
        setAiScene(true);
        const query = "api/courses/lessons/modules/avatars/generate-text";
        const body = {
            id_course: navigationContext.sidebar.courseID,
            id_module: id_module
        };
        const res = await postAPI(query, body);
        if (res.status === "ok") {
            setSceneText(res.data.scene || "");
            setAvatar({ ...avatar, id_avatar: res.data.id_avatar, id_background: avatarBackground.id_background })
        }
        setAiScene(false);
    }
    const showGenerateButtons = avatar && avatarBackground && avatarPosition && !aiLoading && sceneText;

    const generateAudio = async () => {
        setIsAudio(true)
        audioIntervalLoader()
        const query = "api/courses/lessons/modules/avatars/audio";
        const body = {
            id_course: navigationContext.sidebar.courseID,
            id_module: id_module,
            id_avatar: avatar.id_avatar
        };
        const res = await postAPI(query, body);
        if (res.status === "ok") {
            loadAvatar();
        }
        clearInterval(audioInterval)
        setAudioInterval(null)
        setIsAudio(false)
    }


    const audioIntervalLoader = () => {

        const interval = setInterval(() => {
            setAudioLoading(prev => {
                const newValue = (prev + Math.random() * 0.15);
                return newValue
            })
        }, 100)
        setAudioInterval(interval)
    }

    const saveAvatar = async (newAvatar) => {
        const query = "api/courses/lessons/modules/avatars/save";
        const body = {
            id_course: navigationContext.sidebar.courseID,
            id_module: id_module,
            id_avatar: newAvatar.id_avatar,
            avatar: newAvatar.id,
            id_background: newAvatar.id_background,
            position: avatarPosition,
            script_text: sceneText,
            audio_url: newAvatar.audio_id || "",
            video_url: newAvatar.video_url || "",
            video_id: newAvatar.video_id || "",
            progress: newAvatar.progress || 0,
        }
        await postAPI(query, body);

    }

    const handleChangeAvatar = (newAvatar) => {
        const copyAvatar = { ...avatar, ...newAvatar };
        setAvatar(copyAvatar);
        saveAvatar(copyAvatar);
    }
    const handleChangeBackground = (newBackground) => {
        const copyBackground = { ...avatarBackground, ...newBackground };
        setAvatarBackground(copyBackground);
        saveAvatar({ ...avatar, ...copyBackground });
    }
    const generateVideo = async () => {
        const query = "api/courses/lessons/modules/avatars/video";
        setAiLoading(true);
        const body = {
            module_id: id_module,
        }
        const res = await postAPI(query, body);
        if (res.status === "ok") {
            loadAvatar();
        }

    }

    const loadAvatarStatus = async () => {
        const query = 'api/courses/lessons/modules/avatars/status'
        const loadStatus = await getAPI(query)
        loadStatus.data = loadStatus.data.filter(avatar => avatar.progress != 2 && avatar.id_avatar == avatar1.id_avatar)
        if (loadStatus.data.length == 0) {
            setAiLoading(false)
            return false
        }
        setAiLoading(true)
        return true
    }
    const pollAvatarStatus = () => {
        const poll = setInterval(() => {
            const status = loadAvatarStatus()
            if (status == false) {
                toast.showToast('Avatar is gereed', 'success')
                updateAvatarStatus(avatar1.id_modules)
                clearInterval(poll)
            }
        }, 10000)
        return poll
    }

    const updateAvatarStatus = async (id_modules) => {
        const query = 'api/courses/lessons/modules/avatars/status/update'
        const id_modules_body = { "modules": id_modules }
        await updateAPI(query, id_modules_body)

    }

    const canGenerate = !sceneText || aiLoading;
    return (
        <VerticalLayout onClick={() => setCollapsed(!collapsed)} className={`create-avatar-comp ${aiLoading && "overlay-loading"}`} style={{ padding: "2rem", gap: "2rem", position: "relative", maxHeight: collapsed ? "2rem" : "46rem", backgroundColor: collapsed ? "var(--primary-50)" : "var(--card-background-color)", transition: "max-height 0.5s ease-in-out", boxShadow: "0 4px 4px rgba(0, 0, 0, 0.09)" }}>
            {aiLoading && (<Spinner className={"create-avatar-spinner"} />)}
            <HorizontalLayout className="space-between">
                <TitleDescriptionText style={{ paddingBottom: "0", marginTop: "0", paddingTop: "0", margin: collapsed ? "0" : "" }} className={"avatar-title"} title={"Avatar creëren"} description={collapsed? "" : "Creëer hier een avatar voor de informatie die is gegeven in de content."} />
                <IconButton onClick={() => setCollapsed(!collapsed)} icon2={collapsed ? "chevron-down" : "chevron-up"} />
            </HorizontalLayout>
            {!collapsed && (
                <>
                    <SimpleTextAreaForm value={sceneText} onChange={(val) => setSceneText(val)} aiLoading={aiScene} handleAiGenerate={handleAiScene} title={"Avatar scene"} />
                    <HorizontalLayout className="standard-margin-top space-between full-width phone-avatar">
                        <AvatarOptions avatar={avatar} setAvatar={handleChangeAvatar} avatarBackground={avatarBackground} setAvatarBackground={handleChangeBackground} avatarPosition={avatarPosition} setAvatarPosition={setAvatarPosition} avatars={avatars} avatarsBackgrounds={avatarsBackgrounds} setAvatarsBackgrounds={setAvatarsBackgrounds} />
                        <VerticalLayout>
                            <VideoPlayer videoSrc={avatar?.video_url} audio={(avatar?.audio_url && !avatar?.video_url)} audioSrc={avatar?.audio_url} position={avatarPosition} avatar={avatar} avatarBackground={avatarBackground} />
                            <GenerateButtons progressLoading={audioLoading} audioLoading={isAudio} isAudio={(avatar?.audio_url && !avatar?.video_url)} generateVideo={generateVideo} generateAudio={async () => await generateAudio()} canGenerate={canGenerate} show={showGenerateButtons} />
                        </VerticalLayout>
                    </HorizontalLayout>
                </>
            )}
        </VerticalLayout>
    )
}

const AvatarOptions = ({ avatar, setAvatar, avatarBackground, setAvatarBackground, avatarPosition, setAvatarPosition, avatars, avatarsBackgrounds, setAvatarsBackgrounds }) => {
    return (
        <VerticalLayout>
            <AvatarSelection
                selectAvatar={(avatar) => setAvatar(avatar)}
                selectedAvatar={avatar}
                avatars={avatars}

            />
            <AvatarBackgroundSelection
                selectAvatar={(bg) => setAvatarBackground(bg)}
                selectedAvatar={avatarBackground}
                avatarsBackgrounds={avatarsBackgrounds}
                setAvatarsBackgrounds={setAvatarsBackgrounds}
            />
            <AvatarPositionSelection selectedAvatar={avatarPosition} selectAvatar={(pos) => setAvatarPosition(pos)} />
        </VerticalLayout>
    )
}
const GenerateButtons = ({ generateAudio, generateVideo, canGenerate, show, isAudio, audioLoading, progressLoading }) => {
    return (
        <div className="generate-buttons-container" style={{ maxHeight: show ? "100px" : "0", opacity: show ? 1 : 0, }}>
            <HorizontalLayout
                className={`center full-width ${show && "standard-margin-top"}`}
                style={{
                    borderRadius: "1rem",
                    gap: !audioLoading && ".2rem",
                }}
            >
                {audioLoading ? <ProgressBarComplete progress={progressLoading} /> : <IconButton
                    color={"primary-500"}
                    style={{
                        padding: "0.2rem 1.5rem",
                        backgroundColor: "var(--card-background-color)",
                        border: "2px solid var(--border-color)",
                        flex: 1,
                        borderRadius: ".5rem",
                        transition: "all 0.5s ease",
                    }}
                    size={25}
                    disabled={canGenerate}
                    title={"Genereer audio"}
                    icon2={"generate-audio"}
                    onClick={(event) => { event.stopPropagation(); generateAudio() }}
                />}
                <IconButton
                    style={{
                        padding: isAudio ? "0.2rem 1.5rem" : "0",
                        backgroundColor: "var(--card-background-color)",
                        border: "2px solid var(--border-color)",
                        width: isAudio ? "50%" : "0",
                        maxWidth: isAudio ? "15rem" : "0",
                        borderRadius: ".5rem",
                        opacity: isAudio ? 1 : 0,
                        pointerEvents: isAudio ? "auto" : "none",
                        transition: "width 0.5s ease, max-width 0.5s ease, opacity 0.5s ease",
                    }}
                    size={isAudio ? 25 : 0}
                    disabled={canGenerate}
                    title={"Genereer video"}
                    icon2={"generate-video"}
                    color={"primary-500"}
                    onClick={(event) => { event.stopPropagation(); generateVideo() }}
                />
            </HorizontalLayout>
        </div>
    );
};
